import {
  PageBlueprint,
  createFrontendPlugin,
  type FrontendFeature,
} from '@backstage/frontend-plugin-api';

const qaPage = PageBlueprint.make({
  params: {
    path: '/qa',
    loader: () => import('./QaRouter').then(m => <m.QaRouter />),
  },
});

export const qaPlugin: FrontendFeature = createFrontendPlugin({
  pluginId: 'qa',
  extensions: [qaPage],
});
